import { Component, Inject, Input } from '@angular/core';
import camelCase from 'lodash-es/camelCase';

import { IPicture } from '@finder/shared/components/picture/picture.interface';
import { StripHTMLTagsFromStringProvider, STRIP_HTML_TAGS_FROM_STRING } from '@finder/shared/utils/string/stripHtmlTagsFromString';
import { PackageCard } from './package-card.interface';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { AagFacetComponent } from '../aag-facet/aag-facet.component';
import { AnchorComponent } from '../anchor/anchor.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { MediaGalleryComponent } from '../media-gallery/media-gallery.component';
import { ButtonComponent } from '../button/button.component';
import { PictureComponent } from '../picture/picture.component';
import { AlignHeaderDirective } from '@finder/shared/directives/align-text/align-header.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'finder-package-card',
    templateUrl: './package-card.component.html',
    styleUrls: ['./package-card.component.scss'],
    standalone: true,
    imports: [
        AagFacetComponent,
        AlignHeaderDirective,
        AnchorComponent,
        ButtonComponent,
        CommonModule,
        FontIconComponent,
        MediaGalleryComponent,
        PictureComponent,
        SafeHtmlPipe,
    ]
})
export class PackageCardComponent {
    @Input() data: PackageCard;

    public picture: IPicture;
    public flipped = false;

    constructor(
        @Inject(STRIP_HTML_TAGS_FROM_STRING) private stripHtmlTagsFromString: StripHTMLTagsFromStringProvider
    ) { }

    flip() {
        this.flipped = !this.flipped;
    }

    /**
     * @name        focusOnFlip
     * @description focus the current card face title.
     * @param       element {Event} event emitted from (finderElementChange) directive, contains the element that has changed.
     */
    focusOnFlip(element) {
        const title = this.flipped ? '.back-title' : '.front-title';
        element.querySelector(title).focus();
    }

    getLinkId(link) {
        // remove all possible html tags from title and content
        const linkId = this.stripHtmlTagsFromString(`${link} ${this.data.title}`);

        // ensure link is on camel case
        return camelCase(linkId);
    }
}
